import * as React from 'react';
import { Link, navigate } from "gatsby";
import styled from '@emotion/styled';
import axios from "axios";
import config from '../../config.js';
import { useSearchContext } from '../context/SearchContext';

// ロゴのサイズを定義
const LogoSize = styled('img')`
  max-height: 40px; // デスクトップなど大きな画面向けのデフォルトの高さ
  max-width: 200px; // デスクトップなど大きな画面向けのデフォルトの幅
  width: auto;
  height: auto;
  object-fit: contain;

  @media (max-width: 768px) { // スマートフォン向けの表示幅
    max-height: 20px; 
    max-width: 30px;
  }
`;

// ヘッダーのスタイルを定義
const FixedHeader = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #ffffff;
  border-bottom: 1px solid #ccc; // 下側にボーダーの線を追加
  padding: 10px 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); // 影を追加
`;

// ナビゲーションバーのスタイル
const NavBarWrapper = styled('div')`
  display: flex;
  align-items: center; // 縦方向の中央揃え
  justify-content: flex-start; // 水平方向の左揃え
  max-width: 2200px;
  margin: 0 auto; // 中央寄せ
`;


// Header.js の編集箇所
const HeaderTitle = styled('div')`
  font-size: 1.5em; // デスクトップなど大きな画面向けのデフォルトサイズ
  font-weight: bold;
  margin-left: 20px;

  @media (max-width: 768px) { // スマートフォン向けの表示幅
    font-size: 1em; // スマートフォン向けの文字サイズに調整 
    // margin-left: 10px; 
  }
`;

// 検索バーのスタイル
const SearchWrapper = styled('div')`
  display: flex;
  align-items: center;
  margin-left: auto; // 検索バーを右寄せ

  input {
    padding: 8px; // デスクトップ向けのパディング
    border-radius: 4px;
    border: 1px solid #ddd;
    margin-right: 10px;
    font-size: 13.5px; 
  word-break: break-all; // はみ出す単語を強制的に改行させる
    // デスクトップでの入力欄の最大幅を制限したい場合は設定
    // max-width: 220px; 
  }
  button {
    padding: 8px 16px; // デスクトップ向けのパディング
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13.5px; 
  word-break: break-all; // はみ出す単語を強制的に改行させる
    white-space: nowrap; // ボタン内テキストの改行を防ぐ

    &:disabled {
      background-color: #ddd;
      cursor: not-allowed;
    }
  }

  @media (max-width: 768px) { // スマートフォン向けの表示幅
    input {
      padding: 6px 8px; 
      font-size: 13px;  
      margin-right: 5px;
      width: 120px; 
    }
    button {
      padding: 6px 10px; 
      font-size: 13px;  
    }
  }
`;

const Header = ({ location }) => {
  const logoImg = '/images/ADAP-Head.png';
  const { headerTitle, logo } = config.siteMetadata; // logo は { src, alt, link } を持つオブジェクト
  const finalLogoLink = logo.link !== '' ? logo.link : '/';

  const [keyword, setKeyword] = React.useState("");
  const { setdocsValue, setactionValue, setSearchKeyword } = useSearchContext();


  const searchDocs = async (event) => {
    event.preventDefault(); // デフォルトのフォーム送信を防ぐ
    const res = await axios.get("/api/search", {
      params: { keyword },
    });
    setdocsValue(res.data.contents);
    setactionValue(true);
    setSearchKeyword(keyword); // 検索キーワードを設定
    navigate('/searchresultPage');
  };


  return (
    <FixedHeader>
      <NavBarWrapper>
        <Link to={finalLogoLink} className={'navBarBrand'}>
          <LogoSize src={logo.image || logoImg} alt={'logo'} />
        </Link>
        <HeaderTitle dangerouslySetInnerHTML={{ __html: headerTitle }} />
        <SearchWrapper>
          <form method="post" action="#" onSubmit={searchDocs}>
            <input
              type="text"
              placeholder="例：ADAP"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
            <button
              type="submit"
              disabled={!keyword}
            >
              検索
            </button>
          </form>
        </SearchWrapper>
      </NavBarWrapper>
    </FixedHeader>
  );
};

export default Header;
